import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectArchiveData } from "../../features/redux/searchSlice";
import {
  searchArchiveFetch,
  searchArchiveLoadMore,
  returnArchiveStatus,
} from "../../features/action/fetchSearch";
import { resetArchive } from "../../features/redux/searchSlice";
import { useSearch } from "../../context/SearchContext";
import { Button, DateBLock, MembersBlock } from "./main";
import { Disigner } from "./Disigner";
import { Storage } from "./Storage";
import { ready } from "../../util/icon";

const ArchiveSearch = () => {
  const { searchQuery } = useSearch();
  const { archive, hasMore, page } = useSelector(selectArchiveData);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const observerTarget = useRef(null);

  const handleReturn = (id) => {
    dispatch(returnArchiveStatus(id, searchQuery, 1, 40));
  };

  useEffect(() => {
    dispatch(resetArchive());
    const timeoutId = setTimeout(() => {
      dispatch(searchArchiveFetch(searchQuery, 1, 40));
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [dispatch, searchQuery]);

  const loadMore = useCallback(() => {
    if (!isLoading && hasMore && searchQuery) {
      setIsLoading(true);
      dispatch(searchArchiveLoadMore(searchQuery, page + 1, 40));
      setTimeout(() => setIsLoading(false), 1000);
    }
  }, [dispatch, searchQuery, page, hasMore, isLoading]);

  useEffect(() => {
    const target = observerTarget.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      { threshold: 0.1 }
    );

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [loadMore]);

  return (
    <div className="w-[100%]">
      <div className="flex flex-col  mx-auto">
        {/* Заголовки */}
        <div className="flex flex-row  w-full my-4 text-center text-[#9E9E9E] text-[1vw] mx-auto ">
          <button className="w-[8%] ">from</button>
          <button className="w-[8%] ">to</button>
          <div className="w-[16%] ">team members</div>
          <div className="w-[25%] ">order</div>
          <div className="w-[32%] ">place</div>
          <div className="w-[11%] ">finish</div>
        </div>
        <div className="rounded-xl mb-6">
          {archive.map((i) => (
            <div
              key={i._id}
              className="flex flex-row h-[64px] mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb]"
            >
              {DateBLock(i.toDate, i.fromDate)}
              {MembersBlock(i.manager, i.designer, i.sewing)}
              {/* ----------------------------------------Block Number Order----------------------------------------------------- */}
              {i.place.trim() !== "הזמנות למחסן" ? (
                <Disigner i={i} />
              ) : (
                <Storage i={i} />
              )}
              {/* ---------------------------------------Button End-------------------------------------------------- */}
              {Button(ready, () => handleReturn(i._id))}
            </div>
          ))}
        </div>
        {hasMore && (
          <div ref={observerTarget} className="flex justify-center items-center py-4">
            {isLoading && (
              <div className="text-[#9E9E9E] text-sm">Loading...</div>
            )}
          </div>
        )}
        {!hasMore && archive.length > 0 && (
          <div className="text-center text-[#9E9E9E] text-sm py-4">
            All results loaded
          </div>
        )}
      </div>
    </div>
  );
};

export default ArchiveSearch;
